import React from 'react';
import {useSnackbar} from 'notistack';
import {useSubmitHandover} from '../../hooks/useSubmitHandover';
import {useReviewContext} from '../../contexts/ReviewContext';
import {usePrePrecursorGQL} from '../../components/PrecursorForm/usePrePrecursorGQL';
import {ReviewAdviceActionEnum} from '../../schema-types/globalTypes';
import {HandoverSFPNonPADModal} from './HandoverSFPNonPADModal';

type Props = {onClose: () => void};

/**
 * Submission modal for a senior adviser submitting a review they ran themselves,
 * i.e. one that was never sent to a junior adviser for sign off.
 */
export const HandoverSeniorAdviserSubmitModal: React.FC<Props> = ({onClose}) => {
  const {fullSubmit} = useSubmitHandover();
  const {reviewValidation: review} = useReviewContext();
  const {enqueueSnackbar} = useSnackbar();
  const {updateReview} = usePrePrecursorGQL();

  const markAsNoActionAndSubmit = async () => {
    if (!review) {
      enqueueSnackbar('Review data is not available', {variant: 'error'});
      return;
    }

    const res = await updateReview({
      variables: {
        reviewId: review.id,
        adviceAction: ReviewAdviceActionEnum.NO_ADVICE,
      },
    });

    if (!res.data?.updateReview?.ok) {
      enqueueSnackbar('An error occurred when marking the review as No action', {
        variant: 'error',
      });
      return;
    }

    await fullSubmit();
    onClose();
  };

  return (
    <HandoverSFPNonPADModal
      onClose={onClose}
      onNoRequirementsConfirm={markAsNoActionAndSubmit}
    />
  );
};
